














































import { ROUTE_PROJECT_DEFAULT } from '@/areas/projects/projects-routes';
import { ROUTE_SETTINGS } from '@/areas/settings/settings-routes';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { RawLocation } from 'vue-router';
import { DocumentListItem } from '../document-list/document-list-models';

// NO. Do not do this. If you put it in @router, like the other route names, router gets imported in the wrong order and shit goes to hell in a handbasket.
// import { ROUTE_GOTO } from '@/router';
// instead, we'll put it here for now. Later, a centralised list of route names, and perhaps even some factories to make the @#$%ing RawLocations
const ROUTE_GOTO = 'GoTo';

type AssociationItem = {
  key: string;
  text: string;
  extraText?: string;
  to: RawLocation;
  createdDateUtc: Date;
  // could do a tooltip later. Not now though.
};
@Component({})
export default class OtDocumentAssociations extends Vue {
  // * PROPS
  @Prop({ required: true }) public document!: DocumentListItem;
  @Prop({ required: true }) public associationsLink!: RawLocation;
  @Prop({ default: false }) public openLinksInNewTab!: boolean;

  // * REFS

  // * DATA
  private isExpanded = false;

  // * COMPUTED
  private get allAssociations(): AssociationItem[] {
    let results: AssociationItem[] = [];
    if (this.document.organisationAssociations.length) {
      results = results.concat(
        this.document.organisationAssociations.map(x => ({
          key: x.gid,
          text: x.associatedName ?? '',
          to: {
            name: ROUTE_SETTINGS,
            params: { orgId: x.associatedGid },
          },
          createdDateUtc: x.createdDateUtc,
        })),
      );
    }
    if (this.document.projectAssociations.length) {
      results = results.concat(
        this.document.projectAssociations.map(x => ({
          key: x.gid,
          text: x.associatedName ?? '',
          to: {
            name: ROUTE_PROJECT_DEFAULT,
            params: { projectGid: x.associatedGid },
          },
          createdDateUtc: x.createdDateUtc,
        })),
      );
    }
    if (this.document.contractAssociations.length) {
      results = results.concat(
        this.document.contractAssociations.map(x => ({
          key: x.gid,
          text: x.associatedName ?? '',
          to: {
            name: ROUTE_GOTO,
            query: { contractGid: x.associatedGid },
          },
          createdDateUtc: x.createdDateUtc,
        })),
      );
    }
    if (this.document.segmentInstanceAssociations.length) {
      results = results.concat(
        this.document.segmentInstanceAssociations.map(x => ({
          key: x.gid,
          text: `${x.associatedCode ?? ''} - ${x.segmentName}`,
          extraText: `- ${x.associationType.name}`,
          to: {
            name: ROUTE_GOTO,
            query: { workflowGid: x.associatedGid },
          },
          createdDateUtc: x.createdDateUtc,
        })),
      );
    }
    // most recent first
    results = results.sort((a, b) => b.createdDateUtc.getTime() - a.createdDateUtc.getTime());
    return results;
  }
  private get displayedAssociations(): AssociationItem[] {
    return this.allAssociations.slice(0, 6);
  }

  private get hasAnyAssociations(): boolean {
    return this.allAssociations.length > 0;
  }
  private get hasMoreAssociations(): boolean {
    return this.allAssociations.length > 1;
  }
  private get hasEvenMoreAssociations(): boolean {
    return this.allAssociations.length > this.displayedAssociations.length;
  }
  private get firstAssociation(): AssociationItem | null {
    return this.displayedAssociations[0] ?? null;
  }

  // * WATCHERS

  // * METHODS

  // * LIFECYCLE
}
